__turbopack_context__.v({
  "filterButton": "view-module___71o3W__filterButton",
  "filterParagraph": "view-module___71o3W__filterParagraph",
  "filterTitle": "view-module___71o3W__filterTitle",
  "filtersContainer": "view-module___71o3W__filtersContainer",
});
